import {FC, useEffect, useRef} from 'react';
import {useMap} from 'react-map-gl/maplibre';
import {
  TerraDraw,
  TerraDrawPolygonMode,
  TerraDrawSelectMode, ValidateNotSelfIntersecting
} from 'terra-draw';
import { TerraDrawMapLibreGLAdapter } from 'terra-draw-maplibre-gl-adapter';
import {Polygon} from 'geojson';

type Props = {
  onPolygonChange: (geometry: Polygon) => void
};

const GeometryEditor: FC<Props> = ({
  onPolygonChange
}) => {
  const draw = useRef<TerraDraw | null>(null);
  const {current: map} = useMap();

  useEffect(() => {
    if (map) {
      draw.current = new TerraDraw({
        tracked: true,
        adapter: new TerraDrawMapLibreGLAdapter({ map: map.getMap() }),
        modes: [
          new TerraDrawPolygonMode({
            editable: true,
            showCoordinatePoints: true,
            styles: {
              fillColor: '#00FFFF',
            },
            validation: (feature, { updateType }) => {
              if (updateType === 'finish' || updateType === 'commit') {
                return ValidateNotSelfIntersecting(feature);
              }
              return { valid: true };
            }
          }),
          new TerraDrawSelectMode({
            allowManualDeselection: false,
          })
        ],
      });

      draw.current.start();
      draw.current.setMode('polygon');
      console.log('📍 TerraDraw Started');
    }

    return () => {
      draw.current?.setMode('select');
      draw.current?.stop();
      console.log('📍 TerraDraw Stopped');
    };
  }, [map, draw]);

  useEffect(() => {
    if (draw.current) {
      draw.current.on('finish', (id) => handleGeomChanged(id as string));
    }
  }, [draw.current]);

  const handleGeomChanged = (featureId: string) => {
    const feature = draw.current?.getSnapshotFeature(featureId);
    draw.current?.setMode('select');
    if (feature) onPolygonChange(feature.geometry as Polygon);
  };

  return null;
};

export default GeometryEditor;